import type { DiscoverSwissAccessibilityFragment } from '#build/graphql-operations'

export type AccessibilityAmenityFeatureValue = true | 'partial' | false

export type AccessibilityAmenityFeature = {
  '@type': 'LocationFeatureSpecification'
  name: string
  value: AccessibilityAmenityFeatureValue
  valueReference: string
}

export function mapAccessibilityGradeToValue(
  grade: number | null | undefined,
): AccessibilityAmenityFeatureValue | null {
  switch (grade) {
    case 1:
      return true
    case 2:
      return 'partial'
    case 3:
      return false
    default:
      return null
  }
}

export function mapAccessibilityToAmenityFeatures(
  accessibility: DiscoverSwissAccessibilityFragment[],
): AccessibilityAmenityFeature[] {
  return accessibility.flatMap((entry) => {
    const value = mapAccessibilityGradeToValue(entry.grade)
    if (!entry.ratingProfileName || !entry.gradeName || value === null) {
      return []
    }

    return [
      {
        '@type': 'LocationFeatureSpecification',
        name: entry.ratingProfileName,
        value,
        valueReference: entry.gradeName,
      },
    ]
  })
}
